export default {
    en: {
        id: 'exercise6',
        subtitle: 'SUGGESTED STRUCTURE <br> ANALYSIS OF TECHNOLOGY ALTERNATIVES',
        blocks: [
            {
                task: 'Annual Survey shows us behind in 4 out of 6 measures',
                title: "S = ",
                answer: ' ',
                note: 'DE, R1',
                disableEdit: true
            },
            {
                task: 'Have identified causes, set up team to work on changes needed',
                title: "C = ",
                answer: ' ',
                note: 'Sol, R2',
                disableEdit: true
            },
            {
                task: 'What BE doing?',
                title: "Q = ",
                answer: ' ',
                disableEdit: true
            }
        ],
        image: '5b2-6.png',
        withoutAnswers: true,
        hideTaskTitle: true,
        submitButton: 'switch'
    },
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5b/practiceDefiningProblem/i18n/exercise6.js